import { useEffect } from 'react';
import { isWhiteColor } from '../../../Utils/helper';
import { cardServedEvent } from '../../../Utils/StoreHomePageUtils';
import { BannerSubTitle, BannerTitle } from '../BannersGrid/styled';
import { TextWidgetContent, TextWidgetSection } from './styled';

export default function TextWidget(props) {
  let { data } = props;
  useEffect(() => {
    cardServedEvent(data);
  }, []);
  return (
    <TextWidgetSection
      sectionBgColorEnd={data?.sectionBgColorEnd}
      sectionBgColorStart={data?.sectionBgColorStart}
      padding={
        !isWhiteColor(data?.sectionBgColorStart, data?.sectionBgColorEnd)
      }
    >
      <BannerTitle subHeading={data?.subHeading?.length} textWidget>
        {data?.heading && <h2>{data?.heading}</h2>}
        {data?.subHeading ? (
          <BannerSubTitle textWidget>
            <h2>{data?.subHeading} </h2>
          </BannerSubTitle>
        ) : null}
        <TextWidgetContent>
          <p
            dangerouslySetInnerHTML={{
              __html: data.htmlText,
            }}
          />
          {/* </ShowMoreText> */}
        </TextWidgetContent>
      </BannerTitle>
    </TextWidgetSection>
  );
}
